import React from 'react';
import styled from 'styled-components';
import { Typography } from '../../style/Typography.js';
import { Flex } from '../../style/layout.js';

import gloot_horizontal from '../../images/gloot-logo-horizontal.png';
import YoutubeIcon from '../../svg/youtube.svg';
import TwitterIcon from '../../svg/twitter.svg';
import InstagramIcon from '../../svg/instagram.svg';
import FacebookIcon from '../../svg/facebook.svg';
import DiscordIcon from '../../svg/discord.svg';

const StyledFooter = styled.footer`
  width: 100%;
  background: ${props => props.theme.backgrounds.tertiaryDark};
  padding: 28px 0;
  margin-top: 64px;
`;

const ContentWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  text-align: center;

  p,
  a {
    margin: 10px 0;
  }
`;

const StyledLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 14px;
  display: block;

  &:hover {
    text-decoration: underline;
  }

  img {
    opacity: 0.8;
    transition: all 0.2s ease;

    &:hover {
      opacity: 1;
    }
  }
`;

const IconWrapper = styled(Flex)`
  svg {
    cursor: pointer;
    margin: 0 12px;
    opacity: 0.6;
    transition: all 0.2s ease;

    &:hover {
      opacity: 1;
    }
  }
`;

const Logo = styled.img`
  height: 38px;
  width: 103px;
`;

export function Footer() {
  return (
    <StyledFooter>
      <ContentWrapper>
        <StyledLink href="https://play.gloot.com" rel="noopener">
          <Logo src={gloot_horizontal} alt="g-loot" />
        </StyledLink>
        <StyledLink
          href="https://www.overwolf.com/app/g-loot-G-Loot"
          rel="noopener"
          target="_blank"
        >
          Download the G-Loot Client
        </StyledLink>
        <StyledLink
          href="https://gloot.com/privacy-policy"
          rel="noopener"
          target="_blank"
        >
          Privacy policy
        </StyledLink>
        <IconWrapper justify="center" align="center">
          <StyledLink
            href="https://www.youtube.com/channel/UCkd1qPsv1j10r914QU1vOFw"
            rel="noopener"
            target="_blank"
            aria-label="YouTube link"
          >
            <YoutubeIcon />
          </StyledLink>
          <StyledLink
            href="https://twitter.com/glootesports"
            rel="noopener"
            target="_blank"
            aria-label="Twitter link"
          >
            <TwitterIcon />
          </StyledLink>
          <StyledLink
            href="https://discord.gg/Ds9pBhrYFk"
            rel="noopener"
            target="_blank"
            aria-label="Discord link"
          >
            <DiscordIcon />
          </StyledLink>
          <StyledLink
            href="https://instagram.com/glootesports"
            rel="noopener"
            target="_blank"
            aria-label="Instagram link"
          >
            <InstagramIcon />
          </StyledLink>
          <StyledLink
            href="https://www.facebook.com/glootesports"
            rel="noopener"
            target="_blank"
            aria-label="Facebook link"
          >
            <FacebookIcon />
          </StyledLink>
        </IconWrapper>
        <Typography variant="captionSmall" align="center">
          © G-Loot Global Esports AB. <br />
          All rights reserved. Made in Stockholm.
        </Typography>
      </ContentWrapper>
    </StyledFooter>
  );
}
